import axios from 'axios';
import moment from 'moment';

import BaseMitConfigService from './BaseMitConfigService.js';
import BaseMitExternalApiService from './BaseMitExternalApiService.js';

import MitReserveService from './BaseMitReserveService.js';

class MitActivityApiService {
  constructor() {
      this.service = new BaseMitExternalApiService();
      
      this.ACCESS_ROLES = {
        DISABLED: 0,
        USER: 10,
        MANAGER: 20,
        ADMIN: 30,
        '0':'DISABLED',
        '10':'USER',
        '20':'MANAGER',
        '30':'ADMIN'
      };
  }

  isActivityDateTimeValid(dateTimeString){
    return (moment(dateTimeString, "YYYY-MM-DD HH:mm:ss", true).isValid() === true);
  }
  getActivityDateStringLocal(){
    return moment().local().format('YYYY-MM-DD HH:mm:ss').toString();//default to now
  }
  getActivityDateStringUtc(dateStringLocal){
    return moment(dateStringLocal, "YYYY-MM-DD HH:mm:ss").utc().format("YYYY-MM-DD HH:mm:ss").toString();
  }

  adaptToUIModel(activity){
    for(let x = 0; x < activity.length; x++){

      activity[x].createDt = moment(activity[x].createDt).local();
      activity[x].createDtDateTime = activity[x].createDt.format('MMM DD YYYY h:mm:ss a');
      activity[x].createDtDate = activity[x].createDt.format('MMM DD YYYY');
      activity[x].createDtTime = activity[x].createDt.format('h:mm:ss a');
      activity[x].userRole = this.ACCESS_ROLES[activity[x].userRole];

      if(activity[x].data){
        activity[x].data = MitReserveService.convertAPIToUI(activity[x].data, null, null);
      }
      else{
        activity[x].data = null;
      }
      
    }

    return activity;
  }

  requestGetReservationActivity(uniqueId) {
    return new Promise ((resolve, reject) => {
      let reserveUrl = BaseMitConfigService.get('CLIENT_API_RESERVE');
      this.service.getData('GET', reserveUrl, '/api/v1/manager/activity/reservation/'+uniqueId)
        .then((response) => {
            this.adaptToUIModel(response.activity);
            return resolve(response);
        })
        .catch((error) => {
          return reject(error);
        });

    });
  }

  requestGetMyReservationActivity(uniqueId) {
    return new Promise ((resolve, reject) => {

      let reserveUrl = BaseMitConfigService.get('CLIENT_API_RESERVE');
      this.service.getData('GET', reserveUrl, '/api/v1/user/activity/reservation/'+uniqueId)
        .then((response) => {
            this.adaptToUIModel(response.activity);
            return resolve(response);
        })
        .catch((error) => {
          return reject(error);
        });

    });
  }

  requestGetActivity(paging, options) {
    return new Promise ((resolve, reject) => {

      let url = new URL(window.location.origin+'/api/v1/manager/activity');

      for (let prop in options) {
        if (options.hasOwnProperty(prop)) {
            if(prop === 'userRole'){
                options[prop] = this.ACCESS_ROLES[options[prop].toUpperCase()];
            }
          url.searchParams.append(prop, options[prop]);
        }
      }
      for (let prop in paging) {
        if (paging.hasOwnProperty(prop)) {
          url.searchParams.append(prop, paging[prop]);
        }
      }

      let reserveUrl = BaseMitConfigService.get('CLIENT_API_RESERVE');
      this.service.getData('GET', reserveUrl, url.pathname+url.search)
        .then((response) => {
            this.adaptToUIModel(response.activity);
            return resolve(response);
        })
        .catch((error) => {
          return reject(error);
        });

    });
  }
}
export default new MitActivityApiService();
